import { object, string } from "yup";
import i18next from "/app/src/locales/config";

export const resetPasswordSchema = object().shape({
  password: string()
    .required(i18next.t("translation:password_is_required"))
    .min(4, i18next.t("translation:short_password_warning")),
});
